import React, { useEffect, useState } from "react";
import api from "../api/Api.js";
import { useLanguage } from "../context/LanguageContext";
import ImportantToKnow from "../components/ImportantToKnow"; 
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/style.css";

const Policy = () => {
  // const { languageId } = useLanguage();
const { language,t } = useLanguage();
const languageId = language?.lang_id || 1;
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // ============================================================
  // PAGE ID
  // Legacy PHP:
  // page_id = 4
  // ============================================================

  const PAGE_ID = 4;

  // ============================================================
  // FETCH POLICY CONTENT
  // ============================================================

  useEffect(() => {
    const fetchPolicy = async () => {
      try {
        setLoading(true);
        setError("");

        const langId = languageId || 1;

        console.log("Fetching policy content:", {
          page_id: PAGE_ID,
          lang_id: langId,
        });

        const response = await api.get("/contents/content", {
          params: {
            page_id: PAGE_ID,
            lang_id: langId,
          },
        });

        console.log("Policy API response:", response.data);

        if (
          response.data?.success &&
          response.data?.data
        ) {
          setContent(response.data.data);
        } else {
          setContent(null);
          setError(
            response.data?.message ||
              "Unable to load the policy content."
          );
        }
      } catch (err) {
        console.error(
          "Policy content error:",
          err
        );

        setContent(null);

        setError(
          err.response?.data?.message ||
            "Unable to load the policy content. Please try again."
        );
      } finally {
        setLoading(false);
      }
    };

    fetchPolicy();
  }, [languageId]);

  // ============================================================
  // LOADING
  // ============================================================

  if (loading) {
    return (
      <div className="policy-page">
        <div className="container">
          <div className="policy-loading">
            <div
              className="spinner-border"
              role="status"
            >
              <span className="visually-hidden">
                Loading...
              </span>
            </div>

            <p>
              Loading policy...
            </p>
          </div>
        </div>
      </div>
    );
  }

  // ============================================================
  // ERROR
  // ============================================================

  if (error) {
    return (
      <div className="policy-page">
        <div className="container">
          <div className="policy-error">
            <div className="policy-error-icon">
              !
            </div>

            <h3>
              Something went wrong
            </h3>

            <p>
              {error}
            </p>

            <button
              className="policy-retry-btn"
              onClick={() => window.location.reload()}
            >
              Try Again
            </button>
          </div>
        </div>
      </div>
    );
  }

  // ============================================================
  // NO CONTENT
  // ============================================================

  if (!content) {
    return (
      <div className="policy-page">
        <div className="container">
          <div className="policy-empty">
            No policy information is available.
          </div>
        </div>
      </div>
    );
  }

  // ============================================================
  // FINAL UI
  // ============================================================

  return (
    <div className="policy-page">

      {/* HERO */}
	  
	  <div className="bg-box ">
      <section className="modify1 policy-hero">
        <div className="container">
          <div className="policy-hero-inner">

            <span className="policy-label" style={{ textTransform: "uppercase" }}>
              {t("othersnewstatics.othersnewstatic16","Information")}
            </span>

            <h1>
              {content.cont_title}
            </h1>

            <div className="policy-line" />

            <p>
            {t("othersnewstatics.othersnewstatic21", 
            "Please read the following information carefully before your rental")}.
            </p>

          </div>
        </div>
      </section></div>

      {/* CONTENT */}
      <section className="policy-content-section">
        <div className="container">

          <div className="policy-card">

            <div
              className="policy-content"
              dangerouslySetInnerHTML={{
                __html:
                  content.cont_details || "",
              }}
            />

          </div>

        </div>
      </section>

      <ImportantToKnow />

    </div>
  );
};

export default Policy;